type Theme = 'light' | 'dark'

export const useTheme = () => {
  const theme = useState<Theme>('theme', () => 'dark')

  const isDark = computed(() => theme.value === 'dark')
  const isLight = computed(() => theme.value === 'light')

  const applyTheme = (value: Theme) => {
    if (process.client) {
      document.documentElement.setAttribute('data-theme', value)
      localStorage.setItem('eduversity-theme', value)
    }
  }

  const toggleTheme = () => {
    const next = theme.value === 'dark' ? 'light' : 'dark'
    theme.value = next
    applyTheme(next)
  }

  const initTheme = () => {
    if (process.client) {
      const stored = localStorage.getItem('eduversity-theme') as Theme | null
      if (stored) {
        theme.value = stored
      }
      applyTheme(theme.value)
    }
  }

  return {
    theme,
    isDark,
    isLight,
    toggleTheme,
    initTheme,
  }
}
